<script>
/* eslint-disable */
export default {
	name: 'TermsConditions2'
}
</script>
<template>
<div class="terms-conditions-2">
	<p align="center">
		電気料金種別定義書
	</p>
	<p align="center">
		家庭用従量電灯プラン
	</p>
	<p align="left">
		１適用
	</p>
	<p align="left">
		　　１電気料金種別定義書【家庭用従量電灯プラン】(以下、｢本定義書｣といいます。)は、当社の電気供給約款【低圧】(以下、｢電気供給約款｣といいます。)に基づき、電灯または小型機器をご使用のお客さまへ電気を供給するときの料金、その他の条件を定めたものです。
	</p>
	<p align="left">
		　　２本定義書は、離島(その区域内において自らが維持し、及び運用する電線路が自らが維持し、及び運用する主要な電線路と電気的に接続されていない離島として経済産業省令で定めるものに限ります)を除いた日本全国に適用します。
	</p>
	<p align="left">
		　　３本定義書に定める料金および燃料費調整における基準単価の金額はすべて消費税等相当額を含みます。
	</p>
	<p align="left">
		２実施期日
	</p>
	<p align="left">
		　本定義書は、２０１９年６月１日より実施するものとします。
	</p>
	<p align="left">
		３定義
	</p>
	<p align="left">
		　本定義書において定義される言葉は、電気供給約款によるものとします。
	</p>
	<p align="left">
		４適用
	</p>
	<p align="left">
		　　１適用範囲
	</p>
	<p>
		　電灯または小型機器を使用する需要で、以下に該当するものに適用致します。
	</p>
	<table cellspacing="0" cellpadding="0" border="1">
		<tbody>
		<tr>
			<td width="164">
				<p align="center">
					北海道､東北､東京､中部､九州
				</p>
			</td>
			<td width="356">
				<p align="left">
					契約電流が10アンペア以上であり、かつ60アンペア以下であること。
				</p>
			</td>
		</tr>
		<tr>
			<td width="164">
				<p align="center">
					関西､中国､四国
				</p>
			</td>
			<td width="356">
				<p align="left">
					最大需要容量が6キロボルトアンペア未満であること。
				</p>
			</td>
		</tr>
		</tbody>
	</table>
	<p align="left">
		　　２供給電気方式、供給電圧および周波数
	</p>
	<p align="left">
		　供給電気方式および供給電圧は、交流単相２線式標準電圧100ボルトもしくは200ボルトまたは交流単相３線式標準電圧100ボルトおよび200ボルトとし、周波数は、標準周波数50ヘルツまたは60ヘルツといたします。
	</p>
	<p align="left">
		　ただし、供給電気方式および供給電圧については、技術上やむをえない場合には、交流３相３線式標準電圧200ボルトとすることがあります。
	</p>
	<p align="left">
		５契約電流または最大需要容量
	</p>
	<table cellspacing="0" cellpadding="0" border="1">
		<tbody>
		<tr>
			<td width="164">
				<p align="center">
					北海道､東北､東京､中部､九州
				</p>
			</td>
			<td width="356">
				<p align="left">
					イ
					契約電流は､10アンペア､15アンペア､20アンペア､30アンペア､40アンペア､50アンペア､60アンペアのいずれかとし､お客さまの申出によって定めます。
				</p>
				<p align="left">
					ただし､他の小売電気事業者から当社へ契約を切り替える場合は､他の小売電気事業者との
					契約終了時点の契約電流の値を引き継ぐものとします。
				</p>
				<p align="left">
					口
					当社は､一般送配電事業者によって､契約電流に応じて､電流制限器その他の適当な装置(以下｢電流制限器等｣といいます｡)
				</p>
				<p align="left">
					または電流を制限する計量器を取り付けます。
				</p>
				<p align="left">
					ただし､お客さまにおいて使用する最大電流が制限される装置が取り付けられている場合等使用する最大電流が契約電流をこえるおそれがないと認められる場合には、当社は､電流制限器等または電流を制限する計量器を取り付けないことがあります。
				</p>
			</td>
		</tr>
		<tr>
			<td width="164">
				<p align="center">
					関西､中国､四国
				</p>
			</td>
			<td width="356">
				<p align="left">
					八
					最大需要容量が6キロボルトアンペア未満であることの決定は､負荷の実情に応じてお客さまと当社との協議によって行います｡ただし､他の小売電気事業者から当社へ契約を切り替える場合は､原則として､他の小売電気事業者との契約終了時点における最大需要容量が6キロボルトアンペア未満であることの決定を引き継ぐものとします。
				</p>
			</td>
		</tr>
		</tbody>
	</table>
	<p align="left">
		６電気料金
	</p>
	<p align="left">
		　　１料金は、基本料金、従量料金、電気供給約款別表
	</p>
	<p align="left">
		　　　(再生可能エネルギー発電促進賦課金)(3)によって算定された再生可能エネルギー発電促進賦課金および別表１(燃料費調整)により算定された燃料費調整額を加えたものとします。
	</p>
	<p align="left">
		　　　基本料金、従量料金は、別表１ (電気料金)のとおりとします。
	</p>
	<p align="center">
		Ⅲ契約の変更
	</p>
	<p align="left">
		７契約電力の変更
	</p>
	<p align="left">
		　　１当社が、お客さまからの契約電力の変更のお申し込みを承諾した場合には、変更後の契約電力にもとづく変更後の契約電流にもとづく月額最低料金を、変更を承諾したのちに到来する電気の計量日より始まる使用期間の電気料金の計算に適用します。
	</p>
	<p align="left">
		　　２お客さまは、やむを得ない場合を除き、お客さまが契約電力を新たに設定もしくは変更した後の計量日から1年目の日が属する月の計量日まで、契約電流を変更することはできません。
	</p>
	<p align="left">
		　　３契約電流の変更にともない、当社がお客さまに対し、供給条件の説明、契約締結前の書面交付および契約締結後の書面交付を行う場合は、電気供給約款に準じます。
	</p>
	<p align="left">
		８本定義書の変更および廃止
	</p>
	<p align="left">
		　　１当社は、本定義書を変更する場合には、電気供給約款に準じます。
	</p>
	<p align="left">
		　　２当社は、本定義書を廃止することがあります。この場合、当社はあらかじめ一定期間、廃止のお知らせおよび廃止日を当社ホームページに掲載します。
	</p>
	<p align="left">
		　　３本定義書の廃止にともない、当社がお客さまに対し、供給条件の説明、契約締結前の書面交付および契約締結後の書面交付を行う場合は、電気供給約款に準じます。
	</p>
	<table cellspacing="0" cellpadding="0" border="1" align="left">
		<tbody>
		<tr>
			<td width="52" valign="top">
				<p align="center">
					別表1
				</p>
			</td>
		</tr>
		</tbody>
	</table>
	<br/>
	<p align="left">
		１電気料金
	</p>
	<p align="left">
		　最低月額料金、従量料金単価は、次のとおりとします。ただし、契約電流15アンペアの場合は、契約電流10アンペアの1.5倍とします。
	</p>

	<p align="left">
		<strong>・関西エリア</strong>
	</p>
	<p align="left">
		<strong>Aプラン（関西エリア）</strong>
	</p>
	<table cellspacing="0" cellpadding="0" border="1">
		<tbody>
		<tr>
			<td colspan="2" width="64%" nowrap="">
				<p align="center">
					種別・区分
				</p>
			</td>
			<td width="12%" nowrap="">
				<p align="center">
					単位
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="center">
					料金単価（税込）
				</p>
			</td>
		</tr>
		<tr>
			<td colspan="2" width="64%" nowrap="">
				<p align="left">
					最低料金（最初の15kWhまで。<br>
					　　　　　0kWhの場合も発生）
				</p>
			</td>
			<td width="12%" nowrap="">
				<p align="center">
					1契約
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					341.02
				</p>
			</td>
		</tr>
		<tr>
			<td rowspan="3" width="24%" nowrap="">
				<p align="left">
					電力量料金
				</p>
			</td>
			<td width="40%" nowrap="">
				<p align="left">
					第１段階<br>
					15kWhから120kWhまで
				</p>
			</td>
			<td width="12%" rowspan="3" nowrap="">
				<p align="center">
					1kWh
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					20.32
				</p>
			</td>
		</tr>
		<tr>
			<td width="40%" nowrap="">
				<p align="left">
					第２段階<br>
					120kWhをこえ300kWhまで
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					25.80
				</p>
			</td>
		</tr>
		<tr>
			<td width="40%" nowrap="">
				<p align="left">
					第３段階<br>
					300kWhをこえる分
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					26.48
				</p>
			</td>
		</tr>
		<tr>
			<td colspan="4">
				<p align="left">
					照明器具（電灯）やコンセント等で使用する一般の電気機器（小型機器）の最大容量が６（kVA）未満のお客さまに適用される契約種別です。
				</p>
				<p align="left">
					主にご家庭用としてご契約いただいています。電灯は,蛍光灯や白熱灯といった照明器具をいいます。
				</p>
				<p align="left">
					小型機器とは具体的にはテレビ,洗濯機,冷蔵庫,エアコン等の単相100Vまたは200Vで使用する電気機器をいいます。
				</p>
				<p align="left">
					一般の電気機器のほとんどはこの小型機器になります。
				</p>
			</td>
		</tr>
		</tbody>
	</table>

	<p align="left">
		<strong>Bプラン（関西エリア）</strong>
	</p>
	<table cellspacing="0" cellpadding="0" border="1">
		<tbody>
		<tr>
			<td width="64%" colspan="2" nowrap="">
				<p align="center">
					種別・区分
				</p>
			</td>
			<td width="12%" nowrap="">
				<p align="center">
					単位
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="center">
					料金単価（税込）
				</p>
			</td>
		</tr>
		<tr>
			<td colspan="2" width="64%" nowrap="">
				<p align="left">
					基本料金
				</p>
			</td>
			<td width="12%" nowrap="">
				<p align="center">
					1kVA
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					396.00
				</p>
			</td>
		</tr>
		<tr>
			<td rowspan="3" width="24%" nowrap="">
				<p align="left">
					電力量料金
				</p>
			</td>
			<td width="40%" nowrap="">
				<p align="left">
					第１段階<br>
					120kWhまで
				</p>
			</td>
			<td rowspan="3" width="12%" nowrap="">
				<p align="center">
					1kWh
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					17.92
				</p>
			</td>
		</tr>
		<tr>
			<td width="40%" nowrap="">
				<p align="left">
					第２段階<br>
					120kWhをこえ300kWhまで
				</p>
			</td>
			<td  width="24%" nowrap="">
				<p align="right">
					21.21
				</p>
			</td>
		</tr>
		<tr>
			<td width="40%" nowrap="">
				<p align="left">
					第３段階<br>
					300kWhをこえる分
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					21.79
				</p>
			</td>
		</tr>
		<tr>
			<td colspan="4">
				<p align="left">
					照明器具（電灯）やコンセント等で使用する一般の電気機器（小型機器）の契約容量が６kVA以上であり，50kVA未満のお客さまに適用される契約種別です。
				</p>
				<p align="left">
					具体的には，商店，事務所，飲食店やご家庭等で電灯，小型機器を多く使われる場合などに適用しています。
				</p>
				<p align="left">
					全く電気をご使用にならなかった月の基本料金は半額とします。
				</p>
			</td>
		</tr>
		</tbody>
	</table>

	<p align="left">
		<strong>動力プラン（関西エリア）</strong>
	</p>

	<table cellspacing="0" cellpadding="0" border="1">
		<tbody>
		<tr>
			<td colspan="2" width="64%" nowrap="">
				<p align="center">
					種別・区分
				</p>
			</td>
			<td width="12%" nowrap="">
				<p align="center">
					単位
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="center">
					料金単価（税込）
				</p>
			</td>
		</tr>
		<tr>
			<td colspan="2" width="64%" nowrap="">
				<p align="left">
					基本料金
				</p>
			</td>
			<td width="12%" nowrap="">
				<p align="center">
					1kW
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					959.42
				</p>
			</td>
		</tr>
		<tr>
			<td rowspan="2" width="24%" nowrap="">
				<p align="left">
					電力量料金
				</p>
			</td>
			<td width="40%" nowrap="">
				<p align="center">
					夏季
				</p>
			</td>
			<td rowspan="2" width="12%" nowrap="">
				<p align="center">
					1kWh
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					13.59
				</p>
			</td>
		</tr>
		<tr>
			<td width="40%" nowrap="">
				<p align="center">
					他季
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					12.21
				</p>
			</td>
		</tr>
		<tr>
			<td colspan="4">
				<p align="left">
					契約電力が50kW未満で、動力をご使用になる場合に適用となります。
				</p>
				<p align="left">
					具体的には、商店、小規模事務所の冷暖房、アパート・マンションの揚排水など
				</p>
				<p align="left">
					契約電力が0.5kWの場合の基本料金は、契約電力1kWの基本料金の半額とします。全く電気をご使用にならなかった月の基本料金は半額とします。
				</p>
				<p align="left">
					「夏季」とは毎年7月1日～9月30日までの期間をいい、その他の期間を「他季」といいます。
				</p>
				<p align="left">
					電気料金の算定期間中に夏季およびその他季がともに含まれる場合には、計量値を確認するときを除き、使用量を夏季およびその他季の日数の比であん分した値をそれぞれの使用量とします。
				</p>
				<p align="left">
					力率割引（割増し）電気機器の力率をそれぞれの入力によって加重平均した値が、85％を上回る場合は、基本料金を5％割引し、85％を下回る場合は、基本料金を5％割増します。なお、全く電気を使用しない月の力率は85％とみなします。
				</p>
			</td>
		</tr>
		</tbody>
	</table>

	<p align="left">
		<strong>令和プラン（四つ葉電力オリジナルメニュー）</strong>
	</p>

	<table cellspacing="0" cellpadding="0" border="1">
		<tbody>
		<tr>
			<td colspan="2" width="64%" nowrap="">
				<p align="center">
					種別・区分
				</p>
			</td>
			<td width="12%" nowrap="">
				<p align="center">
					単位
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="center">
					料金単価
				</p>
			</td>
		</tr>
		<tr>
			<td colspan="2" width="64%" nowrap="">
				<p align="left">
					１契約あたり基本料金(300kWhまで)
				</p>
			</td>
			<td width="12%" nowrap="">
				<p align="center">
					1契約
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					6926
				</p>
			</td>
		</tr>
		<tr>
			<td width="24%" nowrap="">
				<p align="left">
					電力量料金
				</p>
			</td>
			<td width="40%" nowrap="">
				<p align="left">
					300kWhをこえる分
				</p>
			</td>
			<td width="12%" nowrap="">
				<p align="center">
					1kWh
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					29
				</p>
			</td>
		</tr>
		<tr>
			<td colspan="4">
				<p align="left">
					日曜日に電気代を沢山使いたいご家庭向け　<font color=red>※日曜日24時間電気料金0円</font>
				</p>
				<p align="left">
					契約電力：最大需要量が6kVA未満であること
				</p>
				<p align="left">
					マンション・アパート・戸建など一般家庭向け
				</p>
			</td>
		</tr>
		</tbody>
	</table>

	<p align="left">
		<strong>ステイホームプラン2.0（四つ葉電力オリジナルメニュー）</strong>
	</p>

	<table cellspacing="0" cellpadding="0" border="1">
		<tbody>
		<tr>
			<td colspan="2" width="64%" nowrap="">
				<p align="center">
					種別・区分
				</p>
			</td>
			<td width="12%" nowrap="">
				<p align="center">
					単位
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="center">
					料金単価
				</p>
			</td>
		</tr>
		<tr>
			<td colspan="2" width="64%" nowrap="">
				<p align="left">
					基本料金
				</p>
			</td>
			<td width="12%" nowrap="">
				<p align="center">
					1kVA
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					428.00
				</p>
			</td>
		</tr>
		<tr>
			<td rowspan="3" width="24%" nowrap="">
				<p align="left">
					電力量料金
				</p>
			</td>
			<td width="40%" nowrap="">
				<p align="left">
					ステイタイム
				</p>
			</td>
			<td rowspan="3" width="12%" nowrap="">
				<p align="center">
					1kWh
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					15.00
				</p>
			</td>
		</tr>
		<tr>
			<td width="40%" nowrap="">
				<p align="left">
					ホームタイム
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					29.00
				</p>
			</td>
		</tr>
		<tr>
			<td width="40%" nowrap="">
				<p align="left">
					スリープタイム
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					20.00
				</p>
			</td>
		</tr>
		<tr>
			<td colspan="4">
				<p align="left">
					在宅勤務やお昼に電気を多く使うご家庭向け　※対応エリア：東京・中部・関西・中国・四国・九州
				</p>
				<p align="left">
					※「ステイタイム」とは午前９時～午後６時の時間をいいます。
				</p>
				<p align="left">
					※「ホームタイム」とは午前６時～午前９時および午後６時～午後11時の時間をいいます。
				</p>
				<p align="left">
					※「スリープタイム」とは毎日午後１１時～翌日午前６時の時間をいいます。
				</p>
			</td>
		</tr>
		</tbody>
	</table>

	<p align="left">
		<strong>幸せ電化プラン</strong>
	</p>

	<table cellspacing="0" cellpadding="0" border="1">
		<tbody>
		<tr>
			<td colspan="2" width="64%" nowrap="">
				<p align="center">
					種別・区分
				</p>
			</td>
			<td width="12%" nowrap="">
				<p align="center">
					単位
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="center">
					料金単価
				</p>
			</td>
		</tr>
		<tr>
			<td rowspan="2" width="24%" nowrap="">
				<p align="left">
					基本料金
				</p>
			</td>
			<td width="40%" nowrap="">
				<p align="left">
					最初の10kWまで
				</p>
			</td>
			<td rowspan="2" width="12%" nowrap="">
				<p align="center">
					1kW
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					2,200.00
				</p>
			</td>
		</tr>
		<tr>
			<td width="40%" nowrap="">
				<p align="left">
					10kWをこえる1kWにつき
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					396.00
				</p>
			</td>
		</tr>
		<tr>
			<td rowspan="4" width="24%" nowrap="">
				<p align="left">
					電力量料金
				</p>
			</td>
			<td width="40%" nowrap="">
				<p align="left">
					デイタイム（昼間時間）夏季
				</p>
			</td>
			<td rowspan="4" width="12%" nowrap="">
				<p align="center">
					1kWh
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					28.96
				</p>
			</td>
		</tr>
		<tr>
			<td width="40%" nowrap="">
				<p align="left">
					デイタイム（昼間時間）他季
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					26.33
				</p>
			</td>
		</tr>
		<tr>
			<td width="40%" nowrap="">
				<p align="left">
					リビングタイム（生活時間）
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					22.89
				</p>
			</td>
		</tr>
		<tr>
			<td width="40%" nowrap="">
				<p align="left">
					ナイトタイム（夜間時間）
				</p>
			</td>
			<td width="24%" nowrap="">
				<p align="right">
					15.20
				</p>
			</td>
		</tr>
		<tr>
			<td colspan="4">
				<p align="left">
					電気を多く使うご家庭向け
				</p>
				<p align="left">
					※「デイタイム」とは平日午前10時～午後5時の時間をいいます。
				</p>
				<p align="left">
					※「リビングタイム」とは平日午前7時～午前10時および午後5時～午後11時の時間ならびに休日扱い日の午前7時～午後11時の時間をいいます。<br>
					　なお、休日扱い日とは、土曜日、日曜日、「国民の祝日に関する法律」に規定する休日、1月2日、1月3日、4月30日、5月1日、5月2日、12月30日および12月31日をいいます。
				</p>
				<p align="left">
					※「ナイトタイム」とは毎日午後11時～翌日午前7時の時間をいいます。
				</p>
				<p align="left">
					※「夏季」とは毎年7月1日～9月30日の期間をいい、その他の期間を「他季」といいます。
				</p>
				<p align="left">
					※ 電化割引額 ＝ 割引対象額（ 基本料金 + 電力量料金 ）× 5.5％<br>
					　エコキュート・オール電化住宅・ガス閉栓などその他供給条件を確認させていただきます。
				</p>
			</td>
		</tr>
		</tbody>
	</table>

	<p align="left">
		２燃料費調整
	</p>
	<p align="left">
		　燃料費調整額は供給エリアのみなし小売電気事業者が公表する従量制の燃料費調整単価に準じます。
	</p>
</div>
</template>
<style lang="scss">
	.terms-conditions-2 {
		font-size: 0.7rem;
		overflow-y: scroll;
	}
</style>
